import { useContext } from 'react';

import {
  ActionGroupContextProps,
  ActionGroupContext,
} from '../contexts/ActionGroupContext.js';

export const useActionGroupContext = (): ActionGroupContextProps =>
  useContext(ActionGroupContext);
